import { Phone, MapPin, Navigation } from "lucide-react";
import {
  BUSINESS,
  BUSINESS_HOURS,
  NAV_LINKS,
  DIRECTIONS_URL,
} from "../config/business";
import { useSectionNav } from "../hooks/useSectionNav";

const FOOTER_SERVICES = [
  "Diagnostics & Check Engine Light",
  "Ontario Safety Standards Certificate",
  "Oil Changes & Maintenance",
  "Brake Service",
  "Engine Repair & Rebuilding",
  "A/C & Climate Control",
  "Complete Mechanical Repairs",
];

export const Footer = () => {
  const go = useSectionNav();
  return (
    <footer className="border-t border-white/10 bg-[#0b0c0e]" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <img
            src="/images/logo.png"
            alt="Auto Trust Centre Ltd. — official logo"
            className="h-14 w-auto rounded-[3px]"
          />
          <address className="mt-6 space-y-2 text-sm not-italic leading-relaxed text-[#a6a9b1]">
            <p className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#00AEEF]" />
              <span>
                {BUSINESS.addressLines.map((l) => (
                  <span key={l} className="block">{l}</span>
                ))}
              </span>
            </p>
            <p className="flex items-center gap-2">
              <Phone className="h-4 w-4 shrink-0 text-[#00AEEF]" />
              <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="transition-colors hover:text-white">
                {BUSINESS.phone}
              </a>
            </p>
            <p className="flex items-center gap-2">
              <Navigation className="h-4 w-4 shrink-0 text-[#00AEEF]" />
              <a href={DIRECTIONS_URL} data-testid="footer-directions" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                Get Directions
              </a>
            </p>
          </address>
        </div>

        <nav aria-label="Footer">
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#f4f4f2]">Quick Links</h3>
          <ul className="mt-5 space-y-3 text-sm text-[#a6a9b1]">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button data-testid={`footer-link-${l.id}`} onClick={() => go(l.id)} className="transition-colors hover:text-white">
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button data-testid="footer-link-appointment" onClick={() => go("appointment")} className="transition-colors hover:text-white">
                Book an Appointment
              </button>
            </li>
          </ul>
        </nav>

        <div>
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#f4f4f2]">Services</h3>
          <ul className="mt-5 space-y-3 text-sm text-[#a6a9b1]">
            {FOOTER_SERVICES.map((s) => (
              <li key={s}>
                <button data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => go("services")} className="text-left transition-colors hover:text-white">
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#f4f4f2]">Business Hours</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-[#a6a9b1]">
            {BUSINESS_HOURS.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span>{h.day.slice(0, 3)}</span>
                <span className={h.closed ? "text-[#00AEEF]" : ""}>
                  {h.closed ? "Closed" : `${h.open} – ${h.close}`}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-[#6b6e76] sm:flex-row lg:px-8">
          <p>
            © 2007 – {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </p>
          <p>
            Full-service mechanical auto repair — Mississauga, Ontario
          </p>
        </div>
      </div>
    </footer>
  );
};
